import Enum from "@/utils/Enum";

// 客服电话
 export const ServiceTelType = new Enum(
   { alias: "PLATFORM", text: "平台客服", value: 1 },
  { alias: "SHOP", text: "店铺客服", value: 2 },
  { alias: "NONE", text: "无", value: 0 }
);

 